import { pubsub } from './pubsub';
import { renderProjects } from './projects-render';
import { renderDeleteIcon, renderEditIcon, renderTasks } from './tasks-render';

// creates the assets constantly visible on the page
// sidebar, main content area, menu and menu items
export function homepageUi() {
	const fragment = new DocumentFragment();
	// create menu toggle and hamburger icon
	const menuToggle = document.createElement('div');
	menuToggle.classList.add('menu-toggle');
	const hamburger = document.createElement('div');
	hamburger.classList.add('hamburger');
	const burgerSpan = document.createElement('span');
	// append elements: menuToggle -> hamburger -> burgerSpan
	hamburger.appendChild(burgerSpan);
	menuToggle.appendChild(hamburger);
	// create aside element and its sub-elements
	const sidebar = document.createElement('aside');
	sidebar.classList.add('sidebar');
	// create the app name area
	const appTitle = document.createElement('h2');
	appTitle.innerText = "Odin Projects";
	appTitle.contentEditable = true;
	sidebar.appendChild(appTitle);
	// create the navigation are of the sidebar
	const sidebarNav = document.createElement('nav');
	sidebarNav.classList.add('menu');
	sidebar.appendChild(sidebarNav);
	// create sidebar elements placeholders
	// production elements will be created via JS and appended to the sidebar
	// create filters container and mock filter elements
	const filterContainer = document.createElement('div');

	// all tasks filter element
	const allTasksFilter = document.createElement('a');
	allTasksFilter.href = '#';
	allTasksFilter.textContent = 'All Tasks';
	allTasksFilter.classList.add('menu-item');
	filterContainer.appendChild(allTasksFilter);
	sidebarNav.appendChild(filterContainer);
	// add event listener
	allTasksFilter.addEventListener('click', displayAllTasksOnClick);

	// important tasks filter element
	const importantTasksFilter = document.createElement('a');
	importantTasksFilter.href = '#';
	importantTasksFilter.textContent = 'Important';
	importantTasksFilter.classList.add('menu-item');
	filterContainer.appendChild(importantTasksFilter);
	sidebarNav.appendChild(filterContainer);
	// event listener
	importantTasksFilter.addEventListener('click', displayImportantTasks);

	// today's tasks filter element
	const todayTasksFilter = document.createElement('a');
	todayTasksFilter.href = '#';
	todayTasksFilter.textContent = 'Today';
	todayTasksFilter.classList.add('menu-item');
	filterContainer.appendChild(todayTasksFilter);
	sidebarNav.appendChild(filterContainer);
	// event listener
	todayTasksFilter.addEventListener('click', displayTodaysTasks);

	// this week's tasks filter element
	const weekTasksFilter = document.createElement('a');
	weekTasksFilter.href = '#';
	weekTasksFilter.textContent = 'Week';
	weekTasksFilter.classList.add('menu-item');
	filterContainer.appendChild(weekTasksFilter);
	sidebarNav.appendChild(filterContainer);
	// event listener
	weekTasksFilter.addEventListener('click', displayWeekTasks);

	// project container
	const projectContainer = document.createElement('div');
	projectContainer.classList.add('project-section');
	sidebarNav.appendChild(projectContainer);
		// project container header
	const projectContainerHeaderContainer = document.createElement('div');
	projectContainerHeaderContainer.classList.add('project-container-header-container');
	const projectContainerHeader = document.createElement('div');
	projectContainerHeader.classList.add('project-container-header');
	projectContainerHeader.innerText = 'Projects';
	const addProjectButton = document.createElement('button');
	addProjectButton.classList.add('add-project-button');
	addProjectButton.innerText = '+';
	projectContainerHeaderContainer.appendChild(projectContainerHeader);
	projectContainerHeaderContainer.appendChild(addProjectButton);
	projectContainer.appendChild(projectContainerHeaderContainer);

	// project container content area
	const individualProjectsContainer = document.createElement('div');
	individualProjectsContainer.classList.add('individual-projects-container');
	projectContainer.appendChild(individualProjectsContainer);

	// create the main content area
	// has placehoder content
	const mainContainer = document.createElement('main');
	mainContainer.classList.add('content');
	const welcomeHeading = document.createElement('h1');
	welcomeHeading.classList.add('welcome-heading');
	welcomeHeading.innerText = 'Welcome back!';
	// ADD here a div - projContainer - for the selected project
	const tasksContainer = document.createElement('div');
	tasksContainer.classList.add('ui-tasks-container');
	tasksContainer.innerText = 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officia, explicabo!';
	// append content area elements: mainContainer -> welcomeHeading + tasksContainer
	mainContainer.appendChild(welcomeHeading);
	mainContainer.appendChild(tasksContainer);
	// appending all parent elements to the fragment
	// fragment -> menuToggle + sidebar + mainContainer
	fragment.appendChild(menuToggle);
	fragment.appendChild(sidebar);
	fragment.appendChild(mainContainer);
	// append the fragment to the div with id='app' hardcoded in the html template
	const appContainer = document.querySelector('.app');
	appContainer.appendChild(fragment);
	// toggle responsive sidebar
	toggleSidebar();
}

function toggleSidebar() {
	const menuToggleButton = document.querySelector(".menu-toggle");
	const sidebar = document.querySelector(".sidebar");

	menuToggleButton.addEventListener("click", () => {
		menuToggleButton.classList.toggle("is-active");
		sidebar.classList.toggle("is-active");
	});
}

// adds the rendered projects to the sidebar
export function addProjectsToUI() {
	pubsub.subscribe('projectsRendered', processRenderedProjects);
}

function processRenderedProjects(node) {
	const projectSection = document.querySelector('.individual-projects-container');
	// this helps avoid duplicate projects
	// replaces the nodes with the updated list of project nodes
	projectSection.replaceChildren(node);
}

// loads the project list when the page loads
export function loadProjectListAtLoad() {
	pubsub.subscribe('projectsStored', renderProjects)
}
loadProjectListAtLoad();

// this displays the project and available tasks at the time of the click on project
export function processSelectedProject() {
	pubsub.subscribe('returnSelectedProject', addSelectedProjectToUI);
}

function addSelectedProjectToUI(info) {
	const projectName = info.name;
	const projectIndex = info.projectId;
	const welcomeHeading = document.querySelector('.welcome-heading');
	welcomeHeading.innerText = projectName;

	// create a button to add tasks to the selected project
	const addTaskButton = document.createElement('button');
	addTaskButton.classList.add('add-task-button');
	addTaskButton.innerText = '+Task';
	addTaskButton.setAttribute('data-index', projectIndex);
	welcomeHeading.appendChild(addTaskButton);
	pubsub.publish('taskButtonAdded', projectIndex);

	// add the tasks to the UI
	renderTasks(info.tasks);
}

// this displays the tasks that are added to the project
export function processTasksRendered() {
	pubsub.subscribe('taskRendered', addProjectTasksToUI)
}

function addProjectTasksToUI(node) {
	const taskSection = document.querySelector('.ui-tasks-container');
	taskSection.replaceChildren(node);
}

// processes task info from local storage for the info modal
export function processTaskInfoForModal() {
	pubsub.subscribe('taskInfoForModal', createTaskInfoModal);
}

function createTaskInfoModal(object) {
	// create info modal
	const taskInfoModal = document.createElement('dialog');
	taskInfoModal.classList.add('task-info-modal');
	taskInfoModal.dataset.taskInfoModal = true;

	// task name
	const taskHeaderContainer = document.createElement('div');
	taskHeaderContainer.classList.add('info-modal-header-container');
	const taskHeader = document.createElement('h2');
	taskHeader.textContent = object.name;
	const closeModalButton = document.createElement('button');
	closeModalButton.textContent = 'x';
	closeModalButton.dataset.closeModalButton = true;
	closeModalButton.addEventListener('click', closeTaskInfoModal);
	// appending to container
	taskHeaderContainer.append(taskHeader, closeModalButton);

	// project name
	const projectNameHeading = document.createElement('div');
	projectNameHeading.textContent = 'Project: ';
	const projectName = document.createElement('span');
	projectName.textContent = object.projectName;
	// appending to div
	projectNameHeading.appendChild(projectName);

	// task description
	const taskDescriptionHeading = document.createElement('div');
	taskDescriptionHeading.textContent = 'Info: ';
	const taskDescription = document.createElement('span');
	taskDescription.textContent = object.description;
	// appending to div
	taskDescriptionHeading.appendChild(taskDescription);

	// task date
	const taskDateHeading = document.createElement('div');
	taskDateHeading.textContent = 'Due date: ';
	const taskDate = document.createElement('span');
	taskDate.textContent = object.date;
	// appending to div
	taskDateHeading.appendChild(taskDate);

	// task priority
	const taskPriorityHeading = document.createElement('div');
	taskPriorityHeading.textContent = 'Priority: ';
	const taskPriority = document.createElement('span');
	switch (object.priority) {
		case '3':
			taskPriority.textContent = 'High';
			break;
		case '2':
			taskPriority.textContent = 'Medium';
			break;
		case '1':
			taskPriority.textContent = 'Low';
			break;
	}
	// appending to div
	taskPriorityHeading.appendChild(taskPriority);

	// appending all elements to modal
	taskInfoModal.append(taskHeaderContainer, projectNameHeading, taskDescriptionHeading, taskDateHeading, taskPriorityHeading);

	document.body.appendChild(taskInfoModal);
	taskInfoModal.showModal();
}

function closeTaskInfoModal() {
	const taskInfoModal = document.querySelector('[data-task-info-modal]');
	//taskInfoModal.classList.add('hide');
	// close the modal (it only actually hides it)
	taskInfoModal.close();
	// remove the modal from the DOM to not interfere
	// when a second modal is opened
	taskInfoModal.remove()
}

// get all the tasks and display them on page load
export function displayAllTasksOnLoad() {
	document.addEventListener('DOMContentLoaded', processAllTasksStored, false);
}

// pubsub event published by itself, without assigned data
function processAllTasksStored() {
	//pubsub.subscribe('allTasksStored', listAllTaks);
	pubsub.publish('requestAllTasksStored');
}

// display all tasks when the 'All Tasks' filter is clicked
// exported to local-storate so that it refreshes
// list of tasks after deleting a project
export function displayAllTasksOnClick() {
	const welcomeHeading = document.querySelector('.welcome-heading');
	welcomeHeading.textContent = 'All remaining tasks';
	pubsub.publish('requestAllTasksStored');
}

// list Important tasks
export function displayImportantTasks(){
	const welcomeHeading = document.querySelector('.welcome-heading');
	welcomeHeading.textContent = 'Your important tasks';
	pubsub.publish('requestImportantTasks');
}

// list today's tasks
function displayTodaysTasks() {
	const welcomeHeading = document.querySelector('.welcome-heading');
	welcomeHeading.textContent = 'Today\'s tasks';
	pubsub.publish('requestTodaysTasks');
}

// display the tasks for the current week
function displayWeekTasks() {
	const welcomeHeading = document.querySelector('.welcome-heading');
	welcomeHeading.textContent = 'This week\'s tasks';
	pubsub.publish('requestWeekTasks');
}
